import { Box, IconButton } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { REACT_MANAGE_ACCESSLEVELS } from "../../actions/EndPoints";
import { ReactComponent as Refresh } from "../../assets/DeviceIcon/Refresh.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import {
  AddDoorToAccessLevel,
  DoorList,
} from "../../slices/DoorSlice/DoorSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import AddDeviceDialog from "./AddDeviceDialog";

function AddDeviceToAccessLevel(props) {
  const [totalRecords, setTotalRecords] = useState(1);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const history = useHistory();
  const [rowData, setRowData] = useState([]);
  const { t } = useTranslation();
  const [paging, setPaging] = useState({
    page: 0,
    size: 50,
  });
  const [totalPages, setTotalPages] = useState(0);
  const previousState = props.history.location.state;
  const { darkMode } = useContext(ThemeContext);

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setPaging({
      page: newPage,
      size: size,
    });
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  const handleAddDevice = (data) => {
    const payload = {
      accessGroupId: previousState.id,
      accessLevelName: previousState.name,
      doors: [data.doorId],
      doorNames: data.doorName,
    };
    dispatch(AddDoorToAccessLevel(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "DMSI0010") {
          Toast(t("ACCESS_LEVEL_DOOR_SUCCESS"), "success");
          history.push({
            pathname: REACT_MANAGE_ACCESSLEVELS,
            state: { data: previousState },
          });
        } else {
          Toast(data.code, "error");
        }
      })
      .catch((er) => { });
  };

  useEffect(() => {
    loadData(paging);
  }, [paging]);

  const loadData = (paging) => {
    dispatch(DoorList(paging))
      .unwrap()
      .then((data) => {
        // console.info(data.data)
        if ((data.code = "DMSI0000" && data.data)) {
          setRowData(data.data.doors);
          setPage(data.data.currentPage);
          setTotalPages(data.data.totalPages);
        }
      })
      .catch((er) => { });
  };

  // ------This is for get door list using accessLevel id from store.-------
  const store = useSelector((state) => state.accessLevel);
  const [existingDoor, setExistingDoor] = useState([]);
  useEffect(() => {
    if (!CommonUtil.isEmpty(store.DoorsByAccessLevelId)) {
      setExistingDoor(store.DoorsByAccessLevelId);
    }
  }, [store.DoorsByAccessLevelId]);
  //------------------End------------------

  //------This for filter Doors which are not added in access Level----------

  useEffect(() => {
    if (!CommonUtil.isEmpty(rowData)) {
      const doorData = Array.from(rowData);
      const storeDoorData = Array.from(
        !CommonUtil.isEmpty(existingDoor)
          ? existingDoor.accessGroupDoors
          : [{ doorId: "" }]
      );
      if (storeDoorData.length > 0) {
        const mapDoor = storeDoorData.map((storeDoor) => {
          return doorData.filter((door) => storeDoor.doorId !== door.doorId);
        });
        if (mapDoor[0].length > 0) setRows(mapDoor[0]);
        else Toast(t("ALL_DOOR_MAPPED"), "warning");
      } else setRows(doorData);
    }
  }, [rowData]);
  //-----------------End----------------

  const columns = React.useMemo(
    () => [
      {
        headerName: "",
        sortable: false,
        width: 5,
        renderCell: (params) => {
          return <div></div>;
        },
      },
      {
        field: "doorName",
        headerName: t("DOOR_NAME"),
        flex: 1,
        width: 10,
        valueGetter: (params) => params.row.doorName,
      },
      {
        field: "deviceName",
        headerName: t("VISACCDEV002"),
        flex: 1,
        width: 10,
        valueGetter: (params) => params.row.deviceName,
      },
      {
        field: "siteName",
        headerName: t("COMMON144"),
        flex: 1,
        width: 10,
        valueGetter: (params) => params.row.siteName,
      },
      {
        field: "zoneName",
        headerName: t("COMMON143"),
        flex: 1,
        width: 10,
        valueGetter: (params) => params.row.zoneName,
      },
      {
        field: "deviceproperty",
        headerName: t("PROPERTIES"),
        flex: 1,
        width: 10,
        valueGetter: (params) => params.row.deviceproperty,
      },
      {
        field: "Actions",
        headerName: t("ACTION"),
        type: "actions",
        flex: 1,
        minWidth: 190,
        width: 150,
        headerAlign: "center",
        getActions: (params) => [
          <GridActionsCellItem
            icon={
              <AddDeviceDialog
                data={params.row}
                handleDevice={() => {
                  handleAddDevice(params.row);
                }}
              />
            }
          />,
        ],
      },
    ],
    []
  );

  return (
    <div>
      <>
        <HeaderToolbar title={t("Add_Door")} back_button={true} />
      </>
      <div style={{ width: "100%" }}>
        <Box
          display={"flex"}
          width={"100%"}
          flexDirection={"row-reverse"}
          alignItems={"center"}
        >
          <Box
            style={{
              textAlign: "-webkit-right",
            }}>
            <IconButton onClick={() => loadData(paging)}>
              <Refresh />
            </IconButton>
          </Box>
        </Box>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          dailyReport={true}
          count={totalRecords}
          rowId={(row) => row.doorId}
          pageCount={totalPages}
          pageSize={paging.size}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>
    </div>
  );
}

export default AddDeviceToAccessLevel;
